var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
export class OrderCreate {
    constructor(createOrder) {
        this.note = createOrder.note;
        this.customerInternalComment = createOrder.customerInternalComment;
        this.individual = createOrder.individual;
        this.invoiceAddressId = createOrder.invoiceAddressId;
        this.companyId = createOrder.companyId;
        this.servicePackageId = createOrder.servicePackageId;
        this.reportPackageId = createOrder.reportPackageId;
        this.invoiceReference = createOrder.invoiceReference;
        this.additionalOrderRecipientUserId = createOrder.additionalOrderRecipientUserId;
        this.checkpointOptions = createOrder.checkpointOptions;
        this.fileIDs = createOrder.fileIDs;
        this.educationOrderRequests = createOrder.educationOrderRequests;
        this.countriesBackgroundCheck = createOrder.countriesBackgroundCheck;
        this.criminalRecords = createOrder.criminalRecords;
        this.referencePerson = createOrder.referencePerson;
        this.invoiceSettings = createOrder.invoiceSettings;
        this.externalAtsReference = createOrder.externalAtsReference;
    }
}
__decorate([
    observable
], OrderCreate.prototype, "note", void 0);
__decorate([
    observable
], OrderCreate.prototype, "customerInternalComment", void 0);
__decorate([
    observable
], OrderCreate.prototype, "individual", void 0);
__decorate([
    observable
], OrderCreate.prototype, "invoiceAddressId", void 0);
__decorate([
    observable
], OrderCreate.prototype, "companyId", void 0);
__decorate([
    observable
], OrderCreate.prototype, "servicePackageId", void 0);
__decorate([
    observable
], OrderCreate.prototype, "reportPackageId", void 0);
__decorate([
    observable
], OrderCreate.prototype, "invoiceReference", void 0);
__decorate([
    observable
], OrderCreate.prototype, "additionalOrderRecipientUserId", void 0);
__decorate([
    observable
], OrderCreate.prototype, "checkpointOptions", void 0);
__decorate([
    observable
], OrderCreate.prototype, "fileIDs", void 0);
__decorate([
    observable
], OrderCreate.prototype, "educationOrderRequests", void 0);
__decorate([
    observable
], OrderCreate.prototype, "countriesBackgroundCheck", void 0);
__decorate([
    observable
], OrderCreate.prototype, "criminalRecords", void 0);
__decorate([
    observable
], OrderCreate.prototype, "referencePerson", void 0);
__decorate([
    observable
], OrderCreate.prototype, "invoiceSettings", void 0);
__decorate([
    observable
], OrderCreate.prototype, "externalAtsReference", void 0);
